/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable max-statements */

const ContactData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/contact-data');
const FiscalData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/fiscal-data');
const PostalData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/postal-data');
const PersonalData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/personal-data');
const CrsData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/crs-data');
const RegistralesPjData = () =>
    import(/* webpackChunkName: "RegistralesPjData" */ '@/components/interveners/registrales-pj-data');
const FatcaData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/fatca-data');
import DispatchersMixin from '@/mixins/dispatchers';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
// import mockData from './mockIntervener';
import moment from 'moment';
import uuidv4 from 'uuid/v4';
import Validations from '@/mixins/validations';

/**
 * @override
 * @param {*} intervener interviniente
 * @param {*} now Ahora
 */
export function isMinor(intervener, now = moment()) {
    const birthdate = intervener.personalData ? intervener.personalData.birthdate : intervener.birthdate;
    const intervenerType = intervener.personalData
        ? intervener.personalData.intervener_type
        : intervener.intervener_type;
    return now.diff(moment(birthdate), 'years') < 18 && intervenerType === 'F';
}

export default {
    name: 'IntervenerForm',

    /**
     * @override
     */
    data() {
        return {
            intervenerType: null,
            crsData: null,
            disableLegalIntervenerOption: false,
            isLoading: false
        };
    },

    mixins: [Validations, DispatchersMixin, formatData, keyed],

    props: {
        data: {
            type: Object,
            required: false
        },
        interveners: {
            type: Array,
            required: false
        },
        accountType: {
            type: String,
            required: false
        }
    },
    components: {
        PersonalData,
        ContactData,
        FiscalData,
        PostalData,
        RegistralesPjData,
        CrsData,
        FatcaData
    },
    beforeMount() {
        const numberOfLegalInterveners = this.interveners.filter(intervener => intervener.intervener_type === 'J')
            .length;
        if ((this.accountType === 'J' && numberOfLegalInterveners > 0) || this.accountType === 'F') {
            this.disableLegalIntervenerOption = true;
        }
    },
    methods: {
        /**
         * Cancela los cambios
         */
        cancel() {
            this.formatData();
            this.modifiedData = {};
            this.$emit('cancel');
        },

        validateTinNumber(_intervener) {
            this.$refs[`crsData-${this.key}`].validateTinNumber()
                .then(response => {
                    if (response.data.isTinValid) {
                        this.$emit('save', _intervener);
                    } else {
                        this.$refs[`crsData-${this.key}`].handleInvalidTin();
                        this.$toast.error('Interviniente', 'Revisa los campos marcados en rojo');
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.$toast.error('Interviniente', 'Revisa los campos marcados en rojo');
                })
                .finally(() => this.isLoading = false);
        },

        /**
         * Lanzar evento con la información del interviniente introducida
         */
        submit() {
            const _intervener = {
                uuid: uuidv4()
            };
            const properties = ['personalData', 'contactData', 'fiscalData', 'postalData'];
            if (this.isLegalPerson) {
                properties.push('registralesData');
            }

            if (this.$refs[`crsData-${this.key}`].hasCRSData) {
                properties.push('crsData');
            }

            if (this.$refs[`fatcaData-${this.key}`].hasFatcaData) {
                properties.push('fatcaData');
            }

            this.isLoading = true;
            Promise.all(
                properties.map(prop =>
                    this.$refs[`${prop}-${this.key}`].fetchValidatedData().then(data => ({ prop, data }))
                )
            )
                .then(results => {
                    results.forEach(x => {
                        if (!x.data) {
                            throw new Error(x.prop);
                        }
                        _intervener[x.prop] = x.data;
                    });
                    const crsResult = results.find(result => result.prop === 'crsData');

                    if (crsResult && (crsResult.data.hasOwnProperty('tin_code') || crsResult.data.hasOwnProperty('key_tin_issuer_country'))) {
                        this.validateTinNumber(_intervener);
                    } else {
                        this.isLoading = false;
                        this.$emit('save', _intervener);
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    if (err.message === 'postalData') {
                        this.$toast.error('Interviniente', 'No se ha agregado ninguna dirección postal');
                    } else {
                        this.$toast.error('Interviniente', 'Revisa los campos marcados en rojo');
                    }
                });
        },
        /**
         * Copiar direccion fiscal
         */
        copyFiscalToPostal() {
            this.$refs[`fiscalData-${this.key}`].fetchValidatedData().then(fiscal => {
                this.$refs[`postalData-${this.key}`].addressesTable.items.push({
                    city: fiscal.f_address_city,
                    door: fiscal.f_address_door,
                    floor: fiscal.f_address_floor,
                    key_country: fiscal.f_address_key_country,
                    state: fiscal.f_address_state,
                    key_state: fiscal.f_address_key_state,
                    number: fiscal.f_address_number,
                    postal_code: fiscal.f_address_postal_code,
                    street_1: fiscal.f_address_street_1,
                    street_2: fiscal.f_address_street_2,
                    uuid: uuidv4()
                });
            });
        },

        /**
         * Set intervener type
         * @param {Event} e Evento
         */
        onIntervenerTypeChanged(e) {
            this.intervenerType = e;
            this.$set(this.$refs[`fatcaData-${this.key}`].formattedData, 'tin_code', undefined);
            this.$set(this.$refs[`fatcaData-${this.key}`].formattedData, 'giin_code', undefined);
        },

        /**
         * Set CRS country
         * @param {Event} e Evento
         */
        onFiscalCountryChanged(e) {
            if (e.key === 'ESP') {
                this.$refs[`crsData-${this.key}`].hasCRSData = false;
            } else {
                this.$refs[`crsData-${this.key}`].hasCRSData = e.has_crs;
            }
            this.$refs[`fatcaData-${this.key}`].hasFatcaData = e.key === 'USA';
            if (e.has_crs) {
                this.$set(this.$refs[`crsData-${this.key}`].formattedData, 'key_tin_issuer_country', e);
                this.$refs[`crsData-${this.key}`].setValueEdited('key_tin_issuer_country', e);
            }
        }
    },

    computed: {
        isLegalPerson: {
            /**
             * Get if intervener is legal person
             * @return {Boolean} Returns True if it is legal person
             */
            get() {
                return this.intervenerType === 'J';
            }
        }
    }
};
